import { TypographyProps, typography } from "./variables/typography";
import { ColorProps, colors } from "./variables/colors";
import { ElementProps, elements } from "./variables/elements";
import { SpacingProps, spacings } from "./variables/sizes";
import GlobalStyles from "./globals";

import { DefaultTheme } from "styled-components";

declare module "styled-components" {
    export interface DefaultTheme {
        typography: TypographyProps;
        colors: ColorProps;
        elements: ElementProps;
        spacings: SpacingProps;
    }
}

export const theme: DefaultTheme = {
    typography: { ...typography },
    colors: { ...colors },
    elements: { ...elements },
    spacings: { ...spacings }
};

export { GlobalStyles };
